
.backToTop {
  position: fixed;
  visibility: hidden;
  opacity: 0;
  right: 15px;
  bottom: 15px;
  z-index: 996;
  width: 40px;
  height: 40px;
  transition: all 0.4s;
  color: var(--bs-white);
  line-height: 0;

}

.backToTopActive {
  visibility: visible;
  opacity: 1;
}
